import React, { FC } from "react";
import NcdcRequestInfoBox from "./NcdcRequestInfoBox";
import classNames from "classnames";

type Props = {
    page: number;
    getPage: (seq: number) => void;
}

const NcdcRequestInfo: FC<Props> = ({ page, getPage }) => {

    const goToNext = () => {
        window.scrollTo(0, 0);
        getPage(page + 1);
    }

    return (
        <div className={classNames('ncdc-request-info-wrapper', {'no-show': page !== 0})}>
            <div className={'ncdc-request-info-content'}>
                <div className={'ncdc-request-info-header-wrapper'}>
                    <div className={'ncdc-request-info-header-line-wrapper'}>
                        <div className={'ncdc-request-info-header-line'} />
                    </div>
                    <div className={'ncdc-request-info-header-title'}>
                        데이터 신청 절차 안내
                    </div>
                    {/*<div className={'ncdc-request-info-header-desc'}>*/}
                    {/*    Lorem Ipsum is simply dummy text of the printing and typesetting*/}
                    {/*</div>*/}
                </div>
                <NcdcRequestInfoBox />
                <div className={'ncdc-request-info-button-wrapper'}>
                    <button onClick={goToNext}>데이터 신청 바로가기</button>
                </div>
            </div>
        </div>
    );
}

export default NcdcRequestInfo;
